/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createMaterial } from '../fn/material/create-material';
import { CreateMaterial$Params } from '../fn/material/create-material';
import { deleteMaterial } from '../fn/material/delete-material';
import { DeleteMaterial$Params } from '../fn/material/delete-material';
import { getMaterialFetchCodes } from '../fn/material/get-material-fetch-codes';
import { GetMaterialFetchCodes$Params } from '../fn/material/get-material-fetch-codes';
import { getMaterials } from '../fn/material/get-materials';
import { GetMaterials$Params } from '../fn/material/get-materials';
import { MaterialDetailsDto } from '../models/material-details-dto';
import { patchMaterial } from '../fn/material/patch-material';
import { PatchMaterial$Params } from '../fn/material/patch-material';

@Injectable({ providedIn: 'root' })
export class GeneratedMaterialService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMaterials()` */
  static readonly GetMaterialsPath = '/api/materials';

  /**
   * Gets all materials.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMaterials()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMaterials$Response(params?: GetMaterials$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MaterialDetailsDto>>> {
    return getMaterials(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all materials.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMaterials$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMaterials(params?: GetMaterials$Params, context?: HttpContext): Observable<Array<MaterialDetailsDto>> {
    return this.getMaterials$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MaterialDetailsDto>>): Array<MaterialDetailsDto> => r.body)
    );
  }

  /** Path part for operation `createMaterial()` */
  static readonly CreateMaterialPath = '/api/materials';

  /**
   * Creates a material.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMaterial()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMaterial$Response(params: CreateMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<MaterialDetailsDto>> {
    return createMaterial(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a material.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMaterial$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMaterial(params: CreateMaterial$Params, context?: HttpContext): Observable<MaterialDetailsDto> {
    return this.createMaterial$Response(params, context).pipe(
      map((r: StrictHttpResponse<MaterialDetailsDto>): MaterialDetailsDto => r.body)
    );
  }

  /** Path part for operation `getMaterialFetchCodes()` */
  static readonly GetMaterialFetchCodesPath = '/api/materials/fetch-codes';

  /**
   * Gets the fetch codes a material may carry: the metals the material price import can fetch.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMaterialFetchCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMaterialFetchCodes$Response(params?: GetMaterialFetchCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getMaterialFetchCodes(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the fetch codes a material may carry: the metals the material price import can fetch.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMaterialFetchCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMaterialFetchCodes(params?: GetMaterialFetchCodes$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getMaterialFetchCodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `deleteMaterial()` */
  static readonly DeleteMaterialPath = '/api/materials/{id}';

  /**
   * Deletes a material.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMaterial()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMaterial$Response(params: DeleteMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMaterial(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a material.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMaterial$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMaterial(params: DeleteMaterial$Params, context?: HttpContext): Observable<void> {
    return this.deleteMaterial$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchMaterial()` */
  static readonly PatchMaterialPath = '/api/materials/{id}';

  /**
   * Patches a material.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchMaterial()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchMaterial$Response(params: PatchMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<MaterialDetailsDto>> {
    return patchMaterial(this.http, this.rootUrl, params, context);
  }

  /**
   * Patches a material.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchMaterial$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchMaterial(params: PatchMaterial$Params, context?: HttpContext): Observable<MaterialDetailsDto> {
    return this.patchMaterial$Response(params, context).pipe(
      map((r: StrictHttpResponse<MaterialDetailsDto>): MaterialDetailsDto => r.body)
    );
  }

}
